module.exports = __webpack_public_path__ + "static/site-fact2-73185282c5c49a0080d727fd7e2415de.jpg";